/**
 * Used to combine a Session with its Event for moving data around.
 */
class SessionWithEvent {
    /**
     * @param {Session} session
     * @param {SessionEvent} event
     */
    constructor(session, event) {
        this.session = session;
        this.event = event;

        if (event.ID !== session.eventID) {
            throw new Error(`The supplied event (${event.ID}) does not match the session's event (${session.eventID}).`);
        }
    }
}

module.exports = SessionWithEvent;
